  
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".custom-cart-form").forEach(form => {
        form.addEventListener("submit", function (e) {
            e.preventDefault();

            let productId = this.querySelector(".custom-add-to-cart").getAttribute("data-product-id");
            let variantId = this.querySelector('[name="id"]').value;
            let button = this.querySelector(".custom-add-to-cart");
            let buttonText = button.querySelector(".button-text");
            let spinner = button.querySelector(".spinner");
            let successMessage = document.getElementById(`cart-success-message-${productId}`);

            // Show spinner and disable button
            spinner.style.display = "inline-block";
            buttonText.textContent = "Adding...";
            button.disabled = true;

            let formData = {
                items: [{
                    id: variantId, // Get variant ID dynamically
                    quantity: 1
                }]
            };

            fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData)
            })
            .then(response => response.json())
            .then(data => {
                console.log("Item added:", data);
                updateCartDrawer(); // Refresh cart drawer

                // Show success message
                successMessage.style.display = "block";

                // Open the cart drawer
                openCartDrawer();

                // Reset button after 2 seconds
                setTimeout(() => {
                    spinner.style.display = "none";
                    buttonText.textContent = "Add to Cart";
                    button.disabled = false;
                    successMessage.style.display = "none";
                }, 2000);
            })
            .catch(error => {
                console.error("Error:", error);
                spinner.style.display = "none";
                buttonText.textContent = "Add to Cart";
                button.disabled = false;
            });
        });
    });

    function updateCartDrawer() {
        fetch("/cart.js")
        .then(response => response.json())
        .then(cart => {
            if (typeof updateCartUI === "function") {
                updateCartUI(cart); // Use your theme's cart update function
            } else {
                console.warn("updateCartUI function not found.");
            }
        });
    }

    // Function to open the cart drawer
    function openCartDrawer() {
        const cartDrawer = document.querySelector("cart-drawer"); // Select the cart-drawer element
        if (cartDrawer) {
            // Trigger the cart drawer to open
            cartDrawer.setAttribute('class', 'drawer animate is-empty active');  // Adding active class to ensure it's opened
        }
    }
});
